import { Box, Grid, Link, styled } from "@mui/material";
import { OnlineStoresModel } from "../../../../shared/models/onlineStoresModel";
import BarekamText from "../../../../components/text";

export const Item = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 200px;
`;

export const Name = styled(BarekamText)(({ theme }) => ({
    color: theme.palette.text.primary
}));

const OnlineStore = ({ url, name, imgUrl }: OnlineStoresModel) => {
    return (
        <Item>
            <Link href={url} target="_blank">
                <Box
                    component="img"
                    src={imgUrl}
                    alt={name}
                    sx={{
                        maxWidth: "100%",
                        height: "auto",
                    }}
                />
                <Name variant={"m"} fontWeight={500} align={"center"}>
                    {name}
                </Name>
            </Link>
        </Item>
    )
}

export default OnlineStore;